export enum EReservationStatus {
  PENDING = 'PENDING',
  COMMITTED = 'COMMITTED',
  VOIDED = 'VOIDED',
  EXPIRED = 'EXPIRED',
}

export enum ELedgerKind {
  GRANT = 'GRANT',
  DEBIT = 'DEBIT',
  REFUND = 'REFUND',
  ADJUSTMENT = 'ADJUSTMENT',
}

export interface IWallet {
  id: string;
  userId: string;
  tenantId: string;
  balance: number;
  heldCredits: number;
  currency: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface IReservation {
  id: string;
  walletId: string;
  userId: string;
  tenantId: string;
  operation: string;
  heldAmount: number;
  status: EReservationStatus;
  expiresAt: Date;
  idempotencyKey: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface ILedgerEntry {
  id: string;
  walletId: string;
  userId: string;
  tenantId: string;
  kind: ELedgerKind;
  amount: number;
  operation: string | null;
  reservationId: string | null;
  referenceId: string | null;
  idempotencyKey: string;
  createdAt: Date;
}
